import { updateNeeds, withLoginUser } from 'src/api/user'
import { NeedsForm } from './NeedsForm'

export const NeedsEditor = withLoginUser(({ user }) => (
  <NeedsForm user={user} submit={updateNeeds} />
))
